// @flow
import React, { Fragment } from 'react'
import styled, { css } from 'styled-components'
import { Input, Radio } from 'antd'
import Path from 'routes/path'
import { fontSize, spacing } from 'frontend_core/dist/styles/variables'
import { mediaMin } from 'frontend_core/dist/styles/media'
import SMConst from 'frontend_core/dist/constants/sm-const'
import { wwwUrl } from 'frontend_core/dist/helpers/url'
import Colors from 'components/styles/colors'
import Button from 'components/atoms/Button'
import LinkText from 'components/atoms/LinkText'
import Icon from 'components/atoms/Icon'
import SelectItem from 'components/atoms/SelectItem'
import InputContainer from 'components/molecules/InputContainer'
import FormItem from 'components/molecules/FormItem'
import RadioList from 'components/molecules/RadioList'
import RadioListCreditcard from 'components/molecules/RadioListCreditcard'
import FormSectionTitle from 'components/molecules/FormSectionTitle'
import PartsContainer from 'components/molecules/PartsContainer'
import { imagePath } from 'frontend_core/dist/helpers/image'

const SubSection = styled.div`
  margin-top: ${spacing.medium_2}px;
  border-top: 1px solid ${Colors.grayE};
`
const ExplainCompanyWrapper = styled.div`
  padding-top: ${spacing.medium_3}px;
  border-top: 1px solid ${Colors.grayE};
  ${mediaMin.phone`
    padding-top: ${spacing.large}px;
  `};
`
const PayMethodItem = styled.div`
  padding: ${spacing.medium__15}px 0;
  ${mediaMin.phone`
    padding: ${spacing.medium_2}px 0;
  `} :not(:first-of-type) {
    border-top: 1px solid ${Colors.grayE};
  }

  :last-of-type {
    border-bottom: 1px solid ${Colors.grayE};
  }

  ${({ isBorder }) =>
    isBorder &&
    css`
      border-top: 1px solid ${Colors.grayE};
    `};
  .additionalMargin {
    display: flex;
    align-items: center;
    & > span {
      padding-top: 0;
    }
  }
`
const PayMethodItemTitle = styled.p`
  font-size: ${fontSize.small_3}px;
`
const PayMethodItemContent = styled.div`
  padding-top: ${spacing.medium__15}px;
  margin-top: ${spacing.medium__15}px;
  border-top: 1px dashed ${Colors.grayE};
  ${mediaMin.phone`
    padding-top: ${spacing.medium_2}px;
    margin-top: ${spacing.medium}px;
    margin-top: ${spacing.medium_2}px;
  `};
`
const PayMethodItemContentInner = styled.div`
  padding-left: 28px;
  margin-top: ${spacing.small}px;
  margin-bottom: ${spacing.medium_2}px;
`
const PaidText = styled.p`
  font-size: ${fontSize.small_2}px;
  line-height: 1.4;
  ${({ isAttention }) =>
    isAttention &&
    css`
      color: ${Colors.red};
    `};
`
const ButtonWrap = styled.div`
  margin-top: ${spacing.small_3}px;
  ${mediaMin.phone`
  margin-top: ${spacing.medium}px;
  `};
`
const SelectCardBlockContainer = styled.div`
  display: none;
  padding: ${spacing.medium_3}px 0 ${spacing.small_3}px;
  ${({ isOpen }) =>
    isOpen &&
    css`
      display: block;
    `};
`
const SelectCardBlock = styled.div`
  ${mediaMin.phone`
    display: table;
  `};
  :not(:first-of-type) {
    margin-top: ${spacing.medium_3}px;
  }
`
const SelectCardBlockHead = styled.div`
  font-size: ${fontSize.small_3}px;
  font-weight: bold;
  ${mediaMin.phone`
    display: table-cell;
    width: 160px;
    vertical-align: top;
  `};
`
const SelectCardBlockBody = styled.div`
  margin-top: ${spacing.small_3}px;
  ${mediaMin.phone`
    display: table-cell;
    vertical-align: top;
    width: 300px;
  `};
`
const CardImage = styled.img`
  height: 24px;
  width: auto;

  :not(:first-of-type) {
    margin-left: ${spacing.small}px;
  }
`
const GuideText = styled.pre`
  color: ${Colors.gray9};
  font-size: ${fontSize.small_2}px;
  line-height: 1.27;
  white-space: pre-wrap;
`
const ExpirationDateFormBlock = styled.div`
  display: table;
  table-layout: fixed;
  width: 100%;
`
const ExpirationDateFormBlockForm = styled.div`
  display: table-cell;
  vertical-align: middle;
`
const ExpirationDateFormBlockUnit = styled.div`
  display: table-cell;
  width: 18px;
  text-align: center;
  vertical-align: middle;
`
const FormToGuide = styled.div`
  margin-top: ${spacing.small_3}px;
  ${mediaMin.phone`
    margin-top: ${spacing.small_2}px;
  `};
`
const SelectCardBlockButtonContaier = styled.div`
  ${mediaMin.phone`
    max-width: 300px;
  `};
`
const SelectCardBlockButtonWrapper = styled.div`
  display: inline-block;
  width: 50%;

  &:first-of-type {
    padding-right: ${spacing.small}px;
  }

  &:nth-of-type(2n) {
    padding-left: ${spacing.small}px;
  }
`
const AttentionTextGuide = styled.div`
  color: ${Colors.red};
  font-size: ${fontSize.small_2}px;
  ${mediaMin.phone`
    font-size: ${fontSize.small_3}px;
  `};
`
const AttentionText = styled.div`
  color: ${Colors.black};
  font-size: ${fontSize.small_2}px;
  margin-left: 1em;
  text-indent: -1em;
  line-height: 1.285;
  ${mediaMin.phone`
    font-size: ${fontSize.small_3}px;
  `} :not(:first-of-type) {
    margin-top: ${spacing.small}px;
  }
`
const AttentionTextWrapper = styled.div`
  margin-top: ${spacing.medium}px;
`
const FormWrapper = styled.div`
  margin-top: ${spacing.medium}px;
`
const LogoImage = styled.img`
  height: auto;
  position: relative;
  top: 2px;
`

export type PropTypes = {
  isCorp: boolean,
  radioListCard: Array<{
    number: string,
    value: number | string,
    accountHolder: string,
    expirationDate: string,
    srcCardImage: string,
  }>,
  optionListMonth: Array<{
    label: string,
    value: number | string,
  }>,
  optionListYear: Array<{
    label: string,
    value: number | string,
  }>,
  cardNumber: Array<string>,
  cardNumberErrors: Array<string>,
  cardHolderName: string,
  onChangeCardHolderName: Function,
  cardExpireMonth: string,
  cardExpireYear: string,
  onChangeCardExpire: Function,
  demanded: string,
  isOpenCreditCard?: boolean,
  paymentMethod: number,
  selectedCardId: number,
  onChangePaymentMethod: Function,
  onChangePaymentCard: Function,
  onClickOpenCreditCardForm: Function,
  onClickAddCreditCard: Function,
  onChangeCardNumber: Function,
  onClickImmediatePaidExamination: Function,
  paidAccountStatus: number,
  isNeedNormalPaidExamination: boolean,
  isImmediatablePaidExamination: boolean,
  isOverPaidyAvailablePeriod: boolean,
  isOverPaidyUpperLimitAmount: boolean,
  disabled?: boolean,
}

export default function SelectPayMethodSection(props: PropTypes) {
  const RadioGroup = Radio.Group

  return (
    <div>
      <FormSectionTitle
        title={i18n.t('page.dashboard.reservation.selectPayMethod.title')}
        required
      />
      <SubSection>
        <PayMethodItem>
          <PayMethodItemTitle>
            {i18n.t('page.shared.creditcard')}
          </PayMethodItemTitle>
          <PayMethodItemContent>
            <RadioListCreditcard
              name="paymethod"
              radioList={props.radioListCard}
              widthType="full"
              selectedValue={props.selectedCardId}
              onChange={props.onChangePaymentCard}
            />
          </PayMethodItemContent>
          <PayMethodItemContent>
            <LinkText onClick={props.onClickOpenCreditCardForm}>
              {i18n.t(
                'page.dashboard.reservation.selectPayMethod.addCreditcard',
              )}
              <Icon
                className={
                  props.isOpenCreditCard ? 'fa fa-angle-up' : 'fa fa-angle-down'
                }
                positionType="right"
              />
            </LinkText>
            <SelectCardBlockContainer isOpen={props.isOpenCreditCard}>
              <SelectCardBlock>
                <SelectCardBlockHead>
                  {i18n.t(
                    'page.dashboard.reservation.selectPayMethod.availableCard',
                  )}
                </SelectCardBlockHead>
                <SelectCardBlockBody>
                  <CardImage src={imagePath('www/common/card_visa.png')} />
                  <CardImage src={imagePath('www/common/card_master.png')} />
                  <CardImage src={imagePath('www/common/card_jcb.png')} />
                  <CardImage src={imagePath('www/common/card_amex.png')} />
                  <CardImage src={imagePath('www/common/card_diners.png')} />
                  <CardImage src={imagePath('www/common/card_discover.png')} />
                </SelectCardBlockBody>
              </SelectCardBlock>
              <SelectCardBlock>
                <SelectCardBlockHead>
                  {i18n.t(
                    'page.dashboard.reservation.selectPayMethod.cardNumber',
                  )}
                </SelectCardBlockHead>
                <SelectCardBlockBody>
                  <FormItem
                    renderInput={() => (
                      <PartsContainer width="25%" spacing={spacing.tiny}>
                        <Input
                          size="large"
                          id="cardNumber0"
                          placeholder="0000"
                          value={props.cardNumber[0] || ''}
                          onChange={e =>
                            props.onChangeCardNumber(e.target.value, 0)
                          }
                        />
                        <Input
                          size="large"
                          id="cardNumber1"
                          placeholder="0000"
                          value={props.cardNumber[1] || ''}
                          onChange={e =>
                            props.onChangeCardNumber(e.target.value, 1)
                          }
                        />
                        <Input
                          size="large"
                          id="cardNumber2"
                          placeholder="0000"
                          value={props.cardNumber[2] || ''}
                          onChange={e =>
                            props.onChangeCardNumber(e.target.value, 2)
                          }
                        />
                        <Input
                          size="large"
                          id="cardNumber3"
                          placeholder="0000"
                          value={props.cardNumber[3] || ''}
                          onChange={e =>
                            props.onChangeCardNumber(e.target.value, 3)
                          }
                        />
                      </PartsContainer>
                    )}
                    errorTexts={props.cardNumberErrors}
                  />
                </SelectCardBlockBody>
              </SelectCardBlock>
              <SelectCardBlock>
                <SelectCardBlockHead>
                  {i18n.t(
                    'page.dashboard.reservation.selectPayMethod.accountHolder',
                  )}
                </SelectCardBlockHead>
                <SelectCardBlockBody>
                  <GuideText>
                    {i18n.t(
                      'page.dashboard.reservation.selectPayMethod.accountHolderGuide',
                    )}
                  </GuideText>
                  <FormToGuide>
                    <FormItem
                      renderInput={() => (
                        <Input
                          size="large"
                          placeholder="TARO SPACE"
                          value={props.cardHolderName}
                          onChange={e =>
                            props.onChangeCardHolderName(e.target.value)
                          }
                        />
                      )}
                    />
                  </FormToGuide>
                </SelectCardBlockBody>
              </SelectCardBlock>
              <SelectCardBlock>
                <SelectCardBlockHead>
                  {i18n.t(
                    'page.dashboard.reservation.selectPayMethod.expirationDate',
                  )}
                </SelectCardBlockHead>
                <SelectCardBlockBody>
                  <ExpirationDateFormBlock>
                    <ExpirationDateFormBlockForm>
                      <FormItem
                        renderInput={() => (
                          <SelectItem
                            selectProps={{
                              size: 'large',
                              defaultValue: props.cardExpireMonth,
                              onChange: value =>
                                props.onChangeCardExpire('month', value),
                            }}
                            optionList={props.optionListMonth}
                          />
                        )}
                      />
                    </ExpirationDateFormBlockForm>
                    <ExpirationDateFormBlockUnit>/</ExpirationDateFormBlockUnit>
                    <ExpirationDateFormBlockForm>
                      <FormItem
                        renderInput={() => (
                          <SelectItem
                            selectProps={{
                              size: 'large',
                              defaultValue: props.cardExpireYear,
                              onChange: value =>
                                props.onChangeCardExpire('year', value),
                            }}
                            optionList={props.optionListYear}
                          />
                        )}
                      />
                    </ExpirationDateFormBlockForm>
                  </ExpirationDateFormBlock>
                </SelectCardBlockBody>
              </SelectCardBlock>
              <SelectCardBlock>
                <SelectCardBlockHead>
                  {i18n.t(
                    'page.dashboard.reservation.selectPayMethod.securityCode',
                  )}
                </SelectCardBlockHead>
                <SelectCardBlockBody>
                  <GuideText>
                    {i18n.t(
                      'page.dashboard.reservation.selectPayMethod.securityCodeGuide',
                    )}
                  </GuideText>
                  <FormToGuide>
                    <FormItem
                      renderInput={() => (
                        <InputContainer width="140px">
                          <Input
                            size="large"
                            placeholder="000"
                            value={props.cvc}
                            onChange={e => props.onChangeCvc(e.target.value)}
                          />
                        </InputContainer>
                      )}
                      errorTexts={props.cvcErrors}
                    />
                  </FormToGuide>
                </SelectCardBlockBody>
              </SelectCardBlock>
              <SelectCardBlock>
                <SelectCardBlockHead />
                <SelectCardBlockBody>
                  <SelectCardBlockButtonContaier>
                    <SelectCardBlockButtonWrapper>
                      <Button
                        tag="button"
                        colorType="gray"
                        buttonType="small"
                        fullWidthSp
                        fullWidthPc
                        onClick={props.onClickOpenCreditCardForm}
                      >
                        {i18n.t('page.shared.cancel')}
                      </Button>
                    </SelectCardBlockButtonWrapper>
                    <SelectCardBlockButtonWrapper>
                      <Button
                        tag="button"
                        colorType="blue"
                        buttonType="small"
                        fullWidthSp
                        fullWidthPc
                        onClick={props.onClickAddCreditCard}
                      >
                        {i18n.t('page.shared.add')}
                      </Button>
                    </SelectCardBlockButtonWrapper>
                  </SelectCardBlockButtonContaier>
                </SelectCardBlockBody>
              </SelectCardBlock>
            </SelectCardBlockContainer>
          </PayMethodItemContent>
        </PayMethodItem>
        {!props.isCorp && (
          <RadioGroup
            value={props.paymentMethod}
            disabled={
              props.isOverPaidyUpperLimitAmount ||
              props.isOverPaidyAvailablePeriod
            }
            onChange={e => props.onChangePaymentMethod(e.target.value)}
          >
            <PayMethodItem>
              <Fragment>
                <Radio
                  className="additionalMargin"
                  name="paymethod"
                  value={SMConst.PaymentMethod.Paidy}
                >
                  {i18n.t('page.dashboard.reservation.wordPaidy')}
                  <LogoImage
                    src={imagePath('www/common/paidy_logo.png')}
                    width="40"
                  />
                </Radio>
                {props.isOverPaidyUpperLimitAmount && (
                  <PayMethodItemContentInner>
                    <PaidText isAttention>
                      {i18n.t('page.dashboard.reservation.paidyAttentionText1')}
                    </PaidText>
                  </PayMethodItemContentInner>
                )}
                {props.isOverPaidyAvailablePeriod && (
                  <PayMethodItemContentInner>
                    <PaidText isAttention>
                      {i18n.t('page.dashboard.reservation.paidyAttentionText2')}
                    </PaidText>
                  </PayMethodItemContentInner>
                )}
              </Fragment>
              <PayMethodItemContent>
                <AttentionTextGuide>
                  {i18n.t(
                    'page.dashboard.reservation.selectPayMethod.attentionGuide',
                  )}
                </AttentionTextGuide>
                <AttentionTextWrapper>
                  <AttentionText>
                    {i18n.t(
                      'page.dashboard.reservation.selectPayMethod.attentionText11',
                    )}
                  </AttentionText>
                  <AttentionText>
                    {i18n.t(
                      'page.dashboard.reservation.selectPayMethod.attentionText12',
                    )}
                  </AttentionText>
                  <AttentionText>
                    {i18n.t(
                      'page.dashboard.reservation.selectPayMethod.attentionText13',
                    )}
                  </AttentionText>
                  <AttentionText>
                    {i18n.t(
                      'page.dashboard.reservation.selectPayMethod.attentionText10',
                    )}
                  </AttentionText>
                  <AttentionText>
                    {i18n.t(
                      'page.dashboard.reservation.selectPayMethod.attentionText14',
                    )}
                  </AttentionText>
                  <AttentionText>
                    {i18n.t(
                      'page.dashboard.reservation.selectPayMethod.attentionText15',
                    )}
                  </AttentionText>
                  <AttentionText>
                    {i18n.t(
                      'page.dashboard.reservation.selectPayMethod.attentionText17',
                    )}
                  </AttentionText>
                  <AttentionText>
                    {i18n.t(
                      'page.dashboard.reservation.selectPayMethod.attentionText16.0',
                    )}
                    <LinkText
                      href={wwwUrl('/about/paidy')}
                      target="_blank"
                      inline
                    >
                      {i18n.t(
                        'page.dashboard.reservation.selectPayMethod.attentionText16.1',
                      )}
                    </LinkText>
                    {i18n.t(
                      'page.dashboard.reservation.selectPayMethod.attentionText16.2',
                    )}
                  </AttentionText>
                </AttentionTextWrapper>
              </PayMethodItemContent>
            </PayMethodItem>
          </RadioGroup>
        )}
        {props.isCorp && (
          <RadioGroup
            value={props.paymentMethod}
            onChange={e => props.onChangePaymentMethod(e.target.value)}
          >
            <PayMethodItem isBorder>
              {props.isNeedNormalPaidExamination && (
                <PayMethodItemContentInner>
                  <PaidText>
                    {i18n.t('page.dashboard.reservation.paidAttentionText1')}
                    <br />
                    {i18n.t('page.dashboard.reservation.paidAttentionText2')}
                  </PaidText>
                  <ButtonWrap>
                    <Button
                      buttonType="medium"
                      buttonWidthPc="240"
                      buttonHeightSp="40"
                      fullWidthSp
                      colorType="blue"
                      tag="button"
                      disabled={
                        props.paymentMethod !== SMConst.PaymentMethod.Paid
                      }
                      onClick={() => {
                        window.open(Path.paidSettings())
                      }}
                    >
                      {i18n.t('page.dashboard.reservation.doApplication')}
                    </Button>
                  </ButtonWrap>
                </PayMethodItemContentInner>
              )}
              {props.paidAccountStatus === 1 && (
                <Fragment>
                  <Radio name="paymethod" value={SMConst.PaymentMethod.Paid}>
                    {i18n.t('page.dashboard.reservation.wordPaid')}
                    <LogoImage
                      src={imagePath('www/common/paid_logo.png')}
                      width="49"
                    />
                  </Radio>
                  <PayMethodItemContentInner>
                    <PaidText>
                      {i18n.t('page.dashboard.reservation.paidAttentionText3')}
                    </PaidText>
                  </PayMethodItemContentInner>
                </Fragment>
              )}
              {(props.paidAccountStatus === 2 ||
                props.paidAccountStatus === 3) && (
                <Radio name="paymethod" value={SMConst.PaymentMethod.Paid}>
                  {i18n.t('page.dashboard.reservation.wordPaid')}
                  <LogoImage
                    src={imagePath('www/common/paid_logo.png')}
                    width="49"
                  />
                </Radio>
              )}
              {props.isImmediatablePaidExamination && (
                <Fragment>
                  <Radio name="paymethod" value={SMConst.PaymentMethod.Paid}>
                    {i18n.t('page.dashboard.reservation.wordPaid')}
                    <LogoImage
                      src={imagePath('www/common/paid_logo.png')}
                      width="49"
                    />
                  </Radio>
                  <PayMethodItemContentInner>
                    <PaidText isAttention>
                      {i18n.t('page.dashboard.reservation.paidAttentionText4')}
                    </PaidText>
                    <ButtonWrap>
                      <Button
                        buttonType="medium"
                        buttonWidthPc="240"
                        buttonHeightSp="40"
                        fullWidthSp
                        colorType="blue"
                        tag="button"
                        disabled={
                          props.paymentMethod !== SMConst.PaymentMethod.Paid
                        }
                        onClick={props.onClickImmediatePaidExamination}
                      >
                        {i18n.t('page.dashboard.reservation.doApplication')}
                      </Button>
                    </ButtonWrap>
                  </PayMethodItemContentInner>
                </Fragment>
              )}
              <PayMethodItemContent>
                <AttentionTextGuide>
                  {i18n.t(
                    'page.dashboard.reservation.selectPayMethod.attentionGuide',
                  )}
                </AttentionTextGuide>
                <AttentionTextWrapper>
                  <AttentionText>
                    {i18n.t(
                      'page.dashboard.reservation.selectPayMethod.attentionText1',
                    )}
                  </AttentionText>
                  <AttentionText>
                    {i18n.t(
                      'page.dashboard.reservation.selectPayMethod.attentionText6',
                    )}
                  </AttentionText>
                  <AttentionText>
                    {i18n.t(
                      'page.dashboard.reservation.selectPayMethod.attentionText7',
                    )}
                  </AttentionText>
                  <AttentionText>
                    {i18n.t(
                      'page.dashboard.reservation.selectPayMethod.attentionText8',
                    )}
                  </AttentionText>
                  <AttentionText>
                    {i18n.t(
                      'page.dashboard.reservation.selectPayMethod.attentionText9.0',
                    )}
                    <LinkText href={wwwUrl('/about/paid')} inline>
                      {i18n.t(
                        'page.dashboard.reservation.selectPayMethod.attentionText9.1',
                      )}
                    </LinkText>
                    {i18n.t(
                      'page.dashboard.reservation.selectPayMethod.attentionText9.2',
                    )}
                  </AttentionText>
                  <AttentionText>
                    {i18n.t(
                      'page.dashboard.reservation.selectPayMethod.attentionText10',
                    )}
                  </AttentionText>
                </AttentionTextWrapper>
              </PayMethodItemContent>
            </PayMethodItem>
            {props.companies.map((company, i) => (
              <PayMethodItem key={`company_pay_${i}`}>
                <Radio
                  name="paymethod"
                  value={company.id}
                  onClick={() => props.onClickCompany(company.id)}
                >
                  {i18n.t(
                    'page.dashboard.reservation.selectPayMethod.demandedSomeone',
                    { point: company.name },
                  )}
                </Radio>
              </PayMethodItem>
            ))}
            {props.isSelectedCompany && (
              <ExplainCompanyWrapper>
                <FormSectionTitle
                  title={i18n.t(
                    'page.dashboard.reservation.selectPayMethod.explainSomeone',
                    { someone: props.demanded },
                  )}
                  description={i18n.t(
                    'page.dashboard.reservation.selectPayMethod.explainSomeoneDesc',
                    { someone: props.demanded },
                  )}
                  required
                />
                <FormWrapper>
                  <Input.TextArea
                    value={props.businessUseDescription}
                    rows={4}
                    placeholder={i18n.t(
                      'page.dashboard.reservation.selectPayMethod.explainSomeonePlaceholder',
                    )}
                    onChange={e =>
                      props.onChangeBusinessUseDescription(e.target.value)
                    }
                  />
                </FormWrapper>
              </ExplainCompanyWrapper>
            )}
          </RadioGroup>
        )}
      </SubSection>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/organisms/SelectPayMethodSection/index.jsx